export async function useUserFetch(options: any) {
  return await useCustomFetch("/user/me", options);
}
export async function userFetch(options: any) {
  return await customFetch("/user/me", options);
}
